<template>
      <default-layout>
        <v-layout wrap>
            <v-toolbar flat dense color="primary" dark>
                <v-toolbar-title class="title">Category Editing</v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- <v-btn icon class="mx-0" @click="close">    
                    <v-icon color="white">clear</v-icon>
                </v-btn> -->
            </v-toolbar>

            <editor></editor>
        </v-layout>
    </default-layout>
</template>

<script>
import Editor from "../_components/editor.vue"

export default {
   name: "CategoryEditing",
   components: {
       Editor
   },
   data(){
       return{

       }
   },
   methods:{

   }
}
</script>
